import { LayoutGrid, Presentation, Settings2, Users } from "lucide-react";
import AgencySidebarBrand from "~/components/agencies/AgencySidebarBrand";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "~/components/ui/sidebar";
import { useAuth } from "~/context/AuthContext";
import { Link, useLocation, useNavigate } from "~/lib/team-router";
import { NavUser } from "./NavUser";

export default function AgencySidebar({
  sidebarOpen,
}: {
  sidebarOpen: boolean;
}) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const agency = user?.agency;

  if (!user || !agency) {
    return null;
  }

  const canManage = agency.role === "owner" || agency.role === "admin";
  const displayName = [user.first_name, user.last_name]
    .filter(Boolean)
    .join(" ");

  return (
    <Sidebar collapsible="offcanvas" variant="inset">
      <SidebarHeader className="shrink-0">
        <SidebarMenu>
          <SidebarMenuItem>
            <AgencySidebarBrand
              agency={agency}
              sidebarOpen={sidebarOpen}
              onClick={() => navigate("/agency/home")}
            />
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>

      <SidebarContent>
        <SidebarGroup>
          <SidebarMenu>
            <SidebarMenuItem>
              <SidebarMenuButton
                asChild
                className="py-4 px-2 cursor-pointer"
                tooltip="Home"
                isActive={location.pathname === "/agency/home"}
              >
                <Link to="/agency/home">
                  <LayoutGrid />
                  <span className="text-sm">Home</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
            <SidebarMenuItem>
              <SidebarMenuButton
                asChild
                className="py-4 px-2 cursor-pointer"
                tooltip="Pitches"
                isActive={location.pathname.startsWith("/agency/pitches")}
              >
                <Link to="/agency/pitches">
                  <Presentation />
                  <span className="text-sm">Pitches</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
            {canManage ? (
              <>
                <SidebarMenuItem>
                  <SidebarMenuButton
                    asChild
                    className="py-4 px-2 cursor-pointer"
                    tooltip="People"
                    isActive={location.pathname === "/agency/people"}
                  >
                    <Link to="/agency/people">
                      <Users />
                      <span className="text-sm">People</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
                <SidebarMenuItem>
                  <SidebarMenuButton
                    asChild
                    className="py-4 px-2 cursor-pointer"
                    tooltip="Settings"
                    isActive={location.pathname.startsWith("/agency/settings")}
                  >
                    <Link to="/agency/settings/general">
                      <Settings2 />
                      <span className="text-sm">Settings</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              </>
            ) : null}
          </SidebarMenu>
        </SidebarGroup>
      </SidebarContent>

      <SidebarFooter className="shrink-0 border-t">
        <NavUser
          name={displayName}
          email={user.email}
          avatar={user.picture || ""}
        />
      </SidebarFooter>
    </Sidebar>
  );
}
